/* eslint-disable jsx-a11y/anchor-is-valid */

import React, {Fragment} from "react";
import {Payment, ListPaymentSettingRequest} from "../../http/protocol";
import {createInitialState, ListView, ListViewProps, ListViewState} from "../ListView";
import {Form, FormListener} from "../form/Form";
import {ColumnType} from "../list/list/ColumnType";
import {PagerModel} from "../list/list/PagerModel";
import {ListUtils} from "../list/list/ListUtils";
import {EntityDataTable} from "../list/list/EntityDataTable";
import {ActionType} from "../list/list/DataTable";
import {withRouter} from "react-router";
import {getContainer} from "../../ioc/IOCSetup";
import { PaymentSettingService } from "../../services/PaymentSettingService";

interface State extends ListViewState<ListPaymentSettingRequest> {
    listRequest?: ListPaymentSettingRequest;
    form?: ListPaymentSettingRequest;
    validationMap?: any;
    lookupExpanded?:boolean;
}

interface Props extends ListViewProps{
}

export class PaymentSettingsListView extends ListView<State, ListPaymentSettingRequest> implements FormListener<ListPaymentSettingRequest> {
    
    columns = [
        { property : "id", name : "Id", orderBy : "id"},
        { property : "created", name : "Created", type : ColumnType.DATE},
        { property : "updated", name : "Updated", type : ColumnType.DATE},
        { property : "comments", name : "Comments" }
    ];

    actions = [
        { id: "details", name: "Details", className: "btn btn-primary", type: ActionType.LINK, getLink: (item: any) => {
                return "/payment-setting/" + item.id} 
        },
    ];


    paymentSettingService : PaymentSettingService;

    constructor(props : Props){
        super(props, "/payment-settings");
        this.paymentSettingService = getContainer().getPaymentSettingService();
        this.state = createInitialState(
            { limit: 20, orderBy: "id", ascending: false},
            this.state = {lookupExpanded:false, ...this.state});
    }

    componentDidMount() {
        this.props.history.replace("/payment-settings/list")
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    formDidUpdate(formModel: ListPaymentSettingRequest, validationMap : any): void {
        this.setState({ form : formModel, validationMap : validationMap});
    }

    onSubmitError(): void {

    };

    onSubmit(): void {
        if (this.state.form){
            let listRequest = this.state.form;
            listRequest.offset = 0;
            listRequest.orderBy = "id";
            this.updateListState(listRequest);
        }
        this.props.history.replace("/payment-settings/list")
    };

    pagerChanged(pager : PagerModel) {
        if (this.state.listRequest) {
            var listRequest = ListUtils.toListRequest(this.state.listRequest, pager);
            this.setState({listRequest : listRequest});
        }
    }

    onAction(item : Payment, action : string) : Promise<any> | undefined {
        if (action === "details") {
            this.navigate("/payment-setting/" + item.id);
        }
        return;
    }

    getTitle() {
        return "Payment Settings";
    }

  

    renderContent() {
        if (!this.state.listRequest) {
            return <div />;
        }
        return (
            <Fragment>
                <div>
                    <div className="wrapper wrapper-content">
                        <EntityDataTable service={this.paymentSettingService} 
                            onPagerChange={this.pagerChanged.bind(this)} 
                            columns={this.columns}
                            listRequest={this.state.listRequest} 
                            onAction={this.onAction.bind(this)}
                            actions={this.actions}/>
                    </div>
                </div>
            </Fragment>
        );
    }
}
export default withRouter(PaymentSettingsListView);